export default function () {
  return {
    // the logged in user's favorites, one row per starred system (`system` holds the system id)
    list: []
  }
}
